export const UPDATE_USER_PREFERENCE_DATA = 'UPDATE_USER_PREFERENCE_DATA';
export const FETCH_USER_PREFERENCE_DATA = 'FETCH_USER_PREFERENCE_DATA';
export const FETCH_USER_PREFERENCE_DATA_FAILED = 'FETCH_USER_PREFERENCE_DATA_FAILED';
export const SHOW_CSBD_DASHBOARD = 'SHOW_CSBD_DASHBOARD';
export const SHOW_GBD_DASHBOARD = 'SHOW_GBD_DASHBOARD';
export const SHOW_DEFAULT_DASHBOARD = 'SHOW_DEFAULT_DASHBOARD';
export const GET_RESTRICT_ACCESS_DETAILS = 'GET_RESTRICT_ACCESS_DETAILS';
export const GET_RESTRICT_ACCESS_DETAILS_FAILED = 'GET_RESTRICT_ACCESS_DETAILS_FAILED';
